var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 13H13.5C13.2239 13 13 13.2239 13 13.5V20.5C13 20.7761 13.2239 21 13.5 21H20C20.5523 21 21 20.5523 21 20V14C21 13.4477 20.5523 13 20 13ZM11 11V23H20C21.6569 23 23 21.6569 23 20V14C23 12.3431 21.6569 11 20 11H11Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11H18V14C18 14.5523 17.5523 15 17 15C16.4477 15 16 14.5523 16 14V11Z",
    fill: "#777E91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 13.5C11 13.2239 10.7761 13 10.5 13H4C3.44772 13 3 13.4477 3 14V20C3 20.5523 3.44772 21 4 21H10.5C10.7761 21 11 20.7761 11 20.5V13.5ZM4 11C2.34315 11 1 12.3431 1 14V20C1 21.6569 2.34315 23 4 23H13V11H4Z",
    fill: "#777E91"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11H8V14C8 14.5523 7.55228 15 7 15C6.44772 15 6 14.5523 6 14V11Z",
    fill: "#777E91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3H9C8.44772 3 8 3.44772 8 4V11H16V4C16 3.44772 15.5523 3 15 3ZM9 1C7.34315 1 6 2.34315 6 4V13H18V4C18 2.34315 16.6569 1 15 1H9Z",
    fill: "#777E91"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1H13V4C13 4.55228 12.5523 5 12 5C11.4477 5 11 4.55228 11 4V1Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxes);
export default __webpack_public_path__ + "static/media/boxes.101c29b8deb93507e17e35d2b1cdd7ba.svg";
export { ForwardRef as ReactComponent };